import "./WhatIDoOne.scss";

function WhatIDoThree() {
  return (
    <div className="WhatIDoOne">
      <div className="body">
        <div className="left">
          <img src="assets/AndroidDeveloper.svg" alt="" Android Vector Image />
        </div>
        <div className="right">
          <h2>Data Science & AI</h2>
          <div className="technoloy">
            <div className="item">
              <img src="assets/Tensorflow.png" alt="" />
              <p className="tech-title">Tensorflow</p>
            </div>
            <div className="item">
              <img src="assets/keras.png" alt="" />
              <p className="tech-title">Keras</p>
            </div>
            <div className="item">
              <img src="assets/OpenCV.png" alt="" />
              <p className="tech-title">OpenCV</p>
            </div>
            <div className="item">
              <img src="assets/SableBaseLine.png" alt="" />
              <p className="tech-title">Stable Baseline</p>
            </div>
            <div className="item">
              <img src="assets/Python.png" alt="" />
              <p className="tech-title">Python</p>
            </div>
          </div>
          <div className="desc">
            <p>
              ⚡  Experience of working with Computer Vision and NLP projects
            </p>
            <br />
            <p>
              ⚡  Developing highly scalable production ready models for various deeplearning and statistical use cases
            </p>
            <br />
            <p>
              ⚡ Complex quantitative modelling for dynamic forecasting and time series analysis
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhatIDoThree;
